var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Heading } from '../Heading';
import { Text } from '../Text';
import { User } from 'pcln-icons';
var StyledImage = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-size: cover;\n  background-image: url(", ");\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-size: cover;\n  background-image: url(", ");\n"])), function (props) { return props.src; });
var propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    src: PropTypes.string,
    altText: PropTypes.string,
    initials: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
};
/** @public */
var Avatar = function (_a) {
    var className = _a.className, title = _a.title, subtitle = _a.subtitle, src = _a.src, altText = _a.altText, initials = _a.initials, size = _a.size, color = _a.color;
    return (React.createElement(Flex, { className: className },
        React.createElement(StyledImage, { role: 'img', src: src, alt: altText, size: size, minWidth: size, color: color, p: 2 },
            !src && initials && React.createElement(Text, { fontSize: 1 }, initials.toUpperCase()),
            !src && !initials && React.createElement(User, null)),
        title && (React.createElement(Flex, { flexDirection: 'column', justifyContent: 'center', ml: 3 },
            React.createElement(Heading.h5, { m: 0 }, title),
            React.createElement(Text, { color: 'text.light', fontSize: 0 }, subtitle)))));
};
Avatar.displayName = 'Avatar';
Avatar.propTypes = propTypes;
Avatar.defaultProps = {
    className: '',
    color: 'primary',
    altText: 'avatar',
    size: 40,
};
export default Avatar;
var templateObject_1;
//# sourceMappingURL=Avatar.js.map